import { StyledDialog, StyledDialogActions, StyledDialogContent, StyledDialogTitle } from 'layout/StyledDialog'
import { Button, ComponentVersionsInherit, ComponentVersions_3_0, Typography } from 'opensolar-ui'
import { useTranslate } from 'ra-core'

type LeaveReviewCartPromptProps = {
  open: boolean
  onCancel: () => void
  onConfirm: () => void
}

export const LeaveReviewCartPrompt = ({ open, onCancel, onConfirm }: LeaveReviewCartPromptProps) => {
  const translate = useTranslate()

  return (
    <ComponentVersionsInherit versions={ComponentVersions_3_0}>
      <StyledDialog open={open} onClose={onCancel}>
        <StyledDialogTitle>{translate('Leave the Review Cart page')}?</StyledDialogTitle>
        <StyledDialogContent>
          <Typography textVariant="body1">
            {translate(
              "You have unsaved changes. If you leave, your edits won't be saved. Do you wish to continue"
            )}
            ?
          </Typography>
        </StyledDialogContent>
        <StyledDialogActions>
          <Button variant="contained" color="default" onClick={onCancel}>
            {translate('Cancel')}
          </Button>
          <Button variant="contained" color="primary" onClick={onConfirm}>
            {translate('Leave Page')}
          </Button>
        </StyledDialogActions>
      </StyledDialog>
    </ComponentVersionsInherit>
  )
}
